// extracted by mini-css-extract-plugin
export default {"homePageSlidesBannerContainer":"SlidesBanner_homePageSlidesBannerContainer__zcGUN"};